import React, {
  ReactElement, ReactNode, useMemo, useState,
} from 'react';
import Context, { SecurityContextContent } from './SecurityContext';

interface Props {
  children: ReactNode;
}

const SecurityContextProvider = ({ children }: Props): ReactElement => {
  const [accessToken, setAccessToken] = useState(undefined);
  const [organizationId, setOrganizationId] = useState(undefined);

  const value: SecurityContextContent = useMemo(() => ({
    accessToken, setAccessToken, organizationId, setOrganizationId,
  }), [accessToken, setAccessToken, organizationId, setOrganizationId]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export default SecurityContextProvider;
